module.exports = __webpack_public_path__ + "media/images/spa-8fe028ef2220322166b88a1506a1cff3.jpg";